import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import React from 'react';
import { ModalProps } from '../../../types/modal';
import { PricingTemplate } from '../../../types/contractor';
import UserRole from '../../../../shared/AuthRoles';
import { useDeletePricingTemplateMutation } from '../../../../app/Slices/SevenDayApiSlice';
import toast from '../../../shared/Toast';

interface DeleteModalProps extends ModalProps {
    template: PricingTemplate | null;
}

const DeleteModal = ({ open, onClose, template }: DeleteModalProps) => {
    const loggedInUser = UserRole();

    const [deleteTemplate] = useDeletePricingTemplateMutation();

    const handleDelete = async () => {
        try {
            if (!template?.id) return;

            await deleteTemplate([loggedInUser?.company, template.id]).unwrap();

            onClose();
            toast.success('Template deleted successfully');
        } catch (error) {
            toast.error('Error deleting template');
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                Delete Template
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={1}>
                    <Typography>
                        Are you sure you want to delete <b>{template?.name}</b>?
                    </Typography>
                    <Alert severity='warning'>
                        This action cannot be undone
                    </Alert>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant='contained'
                    color='error'
                    onClick={handleDelete}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteModal;
